import { useCallback, useEffect, useRef, useState } from 'react';
import { fetchDraftTrips, type DraftTrip } from '../api/trip';

type UseDraftTripsResult = {
  drafts: DraftTrip[];
  loading: boolean;
  error: string | null;
  refetch: () => Promise<void>;
};

export const useDraftTrips = (currentTripId: string): UseDraftTripsResult => {
  const [drafts, setDrafts] = useState<DraftTrip[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const prevTripIdRef = useRef(currentTripId);

  const refetch = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const data = await fetchDraftTrips();
      setDrafts(data);
    } catch {
      setError('履歴の取得に失敗しました');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refetch();
  }, [refetch]);

  useEffect(() => {
    if (prevTripIdRef.current !== currentTripId && currentTripId !== 'new') {
      refetch();
      prevTripIdRef.current = currentTripId;
    }
  }, [currentTripId, refetch]);

  return { drafts, loading, error, refetch };
};
